import Vue from 'vue'
import Vuetify, { VLayout } from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VLayout,
  },
})

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#86C95F',
        accent: '#A26EB5',
      },
      dark: {
        primary: '#86C95F',
        accent: '#FFD277',
      },
    },
  },
})
